<template>
  <el-dialog top="30px" title="编辑自建库存" :visible.sync="dialogVisible" width="50%">
    <div class="body">
        <el-col :span="24" style="margin-top:20px;">
        <el-upload
            :action="action"
            list-type="picture-card"
            :fileList="fileList"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :headers="customHeaders"
        >
            <i class="el-icon-plus" style="color: #0724ef;"></i>
        </el-upload>
        <el-divider></el-divider>
        <div class="form">
        <el-button type="primary" @click="AddprocurementLink">新增采购链接</el-button>
        <el-form ref="form" label-width="100px" style="margin-top:10px;">
            <div v-for="(item,index) in linkList" :key="index">
            <el-form-item label="采购链接:">
                <el-input style="width:250px;" v-model="linkList[index]"></el-input>
                <el-link :href="item" target="_blank" type="primary" style="margin-left:20px;height:20px;">访问</el-link>
                <el-link target="_blank" type="danger" style="margin-left:20px;height:20px;" @click="delLink(index)">删除采购链接</el-link>
            </el-form-item>
            </div>
            <el-form-item label="商品全称:">
                <el-input style="width:200px;" placeholder="全称" v-model="fullName"></el-input>
            </el-form-item>
            <el-form-item label="商品简称:">
                <el-input style="width:200px;" placeholder="简称" v-model="simpleName"></el-input>
            </el-form-item>
              <el-form-item label="规格尺寸:">
                <el-input style="width:200px;" placeholder="尺寸" v-model="inventorySku"></el-input>
            </el-form-item>
            <el-form-item label="商品描述:">
                <el-input  style="width:500px;" placeholder="规格型号说明" v-model="describe"></el-input>
            </el-form-item>
            <el-form-item label="库存数量:">
                <span>{{this.sondata.actualCount}}</span>
                <el-button type="primary" size="mini" style="margin-left:30px;"  @click="supplement">补充库存</el-button>
                <!-- <el-button type="danger" size="mini" style="float:right;margin-top:6px;" v-if="this.sondata.actualCount >=1" @click="destruction">销毁库存</el-button> -->
            </el-form-item>
        </el-form>
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="父体匹配" name="first">
            
            <el-button type="primary" style="margin-bottom:10px;margin-top:10px;" @click="matchingSku1">父体匹配SKU</el-button>
              <div style="margin-bottom:20px;">
                <el-table :data="inventorySkus1" border style="width:100%;" height="210">
                  <el-table-column prop="inventorySku" label="SKU" align="center"></el-table-column>
                  <el-table-column label="图片" align="center">
                    <template slot-scope="scope">
                      <img :src="scope.row.skuImagesList[0]" style="width:50px;height:50px;">
                    </template>
                  </el-table-column>
                  <el-table-column prop="address" label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button type="danger" @click="cancelMatching(scope.row)">取消匹配</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                </div>

          </el-tab-pane>

          <el-tab-pane label="变体匹配" name="second">
              <el-button type="primary" style="margin-bottom:10px;margin-top:10px;" @click="matchingSku2">变体匹配SKU</el-button>
              <div style="margin-bottom:20px;">
                <el-table :data="inventorySkus2" border style="width:100%;" height="210">
                  <el-table-column prop="inventorySku" label="SKU" align="center"></el-table-column>
                  <el-table-column label="图片" align="center">
                    <template slot-scope="scope">
                      <img :src="scope.row.skuImagesList[0]" style="width:50px;height:50px;">
                    </template>
                  </el-table-column>
                  <el-table-column prop="address" label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button type="danger" @click="cancelMatching(scope.row)">取消匹配</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                </div>

          </el-tab-pane>
          <el-tab-pane label="自建匹配" name="third">
              <el-button type="primary" style="margin-bottom:10px;margin-top:10px;" @click="matchingSku3">自建SKU</el-button>
              <div style="margin-bottom:20px;">
                <el-table :data="inventorySkus3" border style="width:100%;" height="210">
                  <el-table-column prop="inventorySku" label="SKU" align="center"></el-table-column>
                  <el-table-column label="图片" align="center">
                    <template slot-scope="scope">
                      <img :src="scope.row.skuImagesList[0]" style="width:50px;height:50px;">
                    </template>
                  </el-table-column>
                  <el-table-column prop="address" label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button type="danger" @click="cancelMatching(scope.row)">取消匹配</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                </div>
          </el-tab-pane>
        </el-tabs>
        </div>
        <el-dialog :visible.sync="ImageVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
        </el-col>
        </div>
        <div style="margin-top:20px;">
              <el-table ref="EditTableDo" v-loading="loading" height="250" :data="EditTableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" border>
                <el-table-column label="批次号" prop="inventoryBatchNo" align="center"></el-table-column>
                <el-table-column label="预计库存" prop="predictCount"  align="center"></el-table-column>
                <el-table-column label="实际库存" prop="actualCount"  align="center"></el-table-column>
                <el-table-column label="销毁数/退件数"   align="center">
                	<template slot-scope="scope">
							{{ scope.row.destroyCount }}/{{scope.row.returnCount}}
						</template>
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime"  align="center"></el-table-column>
                <el-table-column label="创建人"  align="center">
                    	<template slot-scope="scope">
							{{ scope.row.userName }}-{{scope.row.roleName}}
						</template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            fixed="right"
                            align="center"
                            width="200"
                        >
						<template slot-scope="scope">
							<el-button :disabled="scope.row.exceptionStatus!=0||scope.row.actualCount ==0" @click="Rejection(scope.row)" type="primary">退件</el-button>
							<el-button :disabled="scope.row.exceptionStatus!=0 ||scope.row.actualCount ==0" @click="CancelBtn(scope.row)" type="danger" >销毁</el-button>
						</template>
					</el-table-column>
              </el-table>
          </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="Add">确定</el-button>
        </div>

        <el-dialog title="匹配SKU" :visible.sync="innerVisible1" append-to-body width="40%" top="15vh">
          <div>
            <el-input v-model="searchInput" placeholder="SKU" style="width:500px;"></el-input>
            <el-button type="primary" style="margin-left:20px;" @click="search">搜索</el-button>
          </div>
          <div style="margin-top:20px;">
              <el-table ref="multipleTable" v-loading="loading" height="250" :data="productList" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" border>
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="图片" width="78" align="center">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="right">
                            <img :src="scope.row.skuImagesList[0]" class="prduct_img">
                            <div class="scope_img" slot="reference" >
                                <img :src="scope.row.skuImagesList[0]" alt style="width:50px;height:50px;"/>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="inventorySku" label="SKU" align="center"></el-table-column>
                <el-table-column label="标题" align="center">
                  <template slot-scope="scope">
                        <el-link :underline="false" class="link">{{scope.row.productTitle}}</el-link>
                  </template>
                </el-table-column>
              </el-table>
          </div>
          
          <span slot="footer" class="dialog-footer">
            <el-button @click="innerVisible1 = false">取消</el-button>
            <el-button type="primary" @click="AddSku">确定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="补充库存" :visible.sync="innerVisible" append-to-body width="25%" top="30vh">
          <div>
            <span>库存补充数量：</span>
            <el-input-number v-model="inventoryNum" size="mini" :min="0" :max="1000" label="描述文字"></el-input-number>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="innerVisible = false">取消</el-button>
            <el-button type="primary" @click="addinventory">确定</el-button>
          </span>
        </el-dialog>
        <!-- ------------------------------------- -->
          <el-dialog title="退件处理" width="50%" :visible.sync="RejectionVisible" append-to-body>
            <el-row type="flex">
                <el-button type="text" @click="NewAddVisible = true">新增地址</el-button>
                <el-button type="text" @click="SelectSite()">选择地址</el-button>
            </el-row>
            <div class="out-handle-box">
                <el-row type="flex">
                    <h4>收件人：</h4>
                    <p>{{ this.innerData.recipientName }}</p>
                </el-row>
                <el-row type="flex">
                    <h4>收货地址：</h4>
                    <p>{{ this.innerData.receivingAddress }}</p>
                </el-row>
                <el-row type="flex">
                    <h4>收件人电话：</h4>
                    <p>{{ this.innerData.recipientTelephone }}</p>
                </el-row>
                <el-input-number v-model="RetreatNum"  :min="1" :max="MaxNum" label="描述文字"></el-input-number>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="RejectionVisible = false">取 消</el-button>
                <el-button type="primary" @click="SalesReturn()">确 定</el-button>
            </div>

            <el-dialog top="30px" width="40%" title="选择地址" :visible.sync="SelectVisible" append-to-body>
                <el-table :data="SiteList" border>
                    <el-table-column
                        property="recipientName"
                        label="收件人"
                        width="100"
                        align="center"
                    ></el-table-column>
                    <el-table-column property="receivingAddress" label="收件地址" align="center"></el-table-column>
                    <el-table-column
                        property="recipientTelephone"
                        label="电话"
                        width="200"
                        align="center"
                    ></el-table-column>
                    <el-table-column label="操作" width="140" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" @click="addressConfirm(scope.row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="thirdVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <el-dialog width="600px" title="新增地址" :visible.sync="NewAddVisible" append-to-body>
              <el-form label-width="100px">
                <el-form-item label="收货地址">
                  <el-input v-model="Newly.receivingAddress"></el-input>
                </el-form-item>
                <el-form-item label="收件人">
                  <el-input v-model="Newly.recipientName"></el-input>
                </el-form-item>
                <el-form-item label="收件人电话">
                  <el-input v-model="Newly.recipientTelephone"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="NewAddVisible = false">取 消</el-button>
                 <el-button type="primary" @click="NewlyAdd">确 定</el-button>
              </div>
            </el-dialog>

        </el-dialog>
          <el-dialog title="销毁处理" width="50%" :visible.sync="CancelVisible" append-to-body>
            <div class="out-handle-box">
                <el-input-number v-model="CancelNum"  :min="1" :max="MaxNum" label="描述文字"></el-input-number>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="CancelVisible = false">取 消</el-button>
                <el-button type="primary" @click="CancelRuin()">确 定</el-button>
            </div>
        </el-dialog>
  </el-dialog>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
  name: "Addcommodity",
  data() {
    return {
            RejectionVisible:false,
            NewAddVisible:false,
            SelectVisible:false,
            CancelVisible:false,
            innerData:{},
            SiteList:[],
            Newly:{
                receivingAddress:"",
                recipientName:"",
                recipientTelephone:""
            },
            // 计数器
            RetreatNum:0,
            CancelNum:0,
            MaxNum:0,
            // 退件字段
            SalesCancel:{},
            // 销毁
            CancelCancel:{},
            // ---------------------------------
            activeName: 'first',
            sondata:"",
            dialogVisible:false,
            innerVisible:false,
            innerVisible1:false,
            action: Baseurl + "imageController/uploadImage",
            dialogImageUrl: [],
            imageData: [],
            customHeaders: { token: localStorage.getItem("token") },
            fileList:[],
            ImageVisible:false,

            linkList:[],
            imagesList:[],
            arrList:[],


            fullName:"",
            simpleName:"",
            describe:"",
            inventorySku:"",
            Num:"",
            id:"",
            inventorySkus:[],
            inventory:"",
            inventoryNum:"",
            inventorySkus1:[],
            inventorySkus2:[],
            inventorySkus3:[],
            multipleSelection:[],

            currentPage: 1,
            pagesize: 5,
            size: 5,
            total: 0,
            Skutype:1,
            loading:false,
            searchInput:"",
            productList:[],
            sondataId:"",
            EditTableData:[],
            EditTable:{
                    inventoryNumber:""
                }
    };
  },
  mounted() {},
  created() {
    this.str = JSON.parse(localStorage.getItem("role"));
    let _this=this;
	  window.toWaringInfo2=_this.toWaringInfo2;
  },
  methods: {
    //   销毁按钮
    CancelBtn(item){
      
        this.CancelNum = item.actualCount;
        this.MaxNum = item.actualCount;
        this.CancelVisible = true;
        this.CancelCancel = {
            id:item.id,
            roleId:this.str.rid,
            destroyCount:this.CancelNum
        }
        // this.CancelCancel.id = item.id;
        // this.CancelCancel.roleId = item.roleId;
        // this.CancelCancel.destroyCount = this.CancelNum;
       
    },
    //   销毁 确定
    CancelRuin(){
     
        this.CancelCancel.destroyCount = this.CancelNum;
        // return;
        ajaxPost(Baseurl+"inventoryController/applyDestroyInventory",this.CancelCancel).then(res=>{
            if(res.data.code==200){
                  this.$message({
                        message: '销毁成功',
                        type: 'success'
                    });
                    this.CancelVisible = false;
                    this.initAjax();
            }else{
                 this.$message.error(res.data.message);
            }
        })
    },
    //  退货
    SalesReturn(){
        // 退货数量
        this.SalesFields.returnCount = this.RetreatNum;
        // console.log(this.SalesFields);
        // return;
        ajaxPost(Baseurl+"inventoryController/applyReturnInventory",this.SalesFields).then(res=>{
            if(res.data.code == 200){
                 this.$message({
                        message: '退件成功',
                        type: 'success'
                    });
                     this.initAjax();
                     this.RejectionVisible = false;
            }else{
                 this.$message.error(res.data.message);
            }
        })
    },
    // 退件操作
    Rejection(item){
        this.SalesFields = {
            id:item.id,
            roleId: this.str.rid
        }
        // this.SalesFields.id=item.id;
        // this.SalesFields.roleId = item.roleId
        this.RejectionVisible = true;
        this.RetreatNum = item.actualCount;
        this.MaxNum = item.actualCount;
            // this.MaxNum = 10;
        let RejeObj = {
            companyId:item.companyId
        }
        // 退货信息
        ajaxPost(Baseurl+"logisticsController/selectDefaultAddressByCompanyId",RejeObj).then(res=>{
            this.SalesFields.receivingAddressId = res.data.data.id;
            this.innerData = res.data.data;
        })
    },
    //  新增地址
    NewlyAdd(){
        this.Newly.companyId = this.str.company_id;
        if(this.Newly.recipientName == ""){
             this.$message.error("收件人姓名不能为空！");
             return;
        }else if(this.Newly.receivingAddress == ""){
             this.$message.error("收件地址不能为空！")
             return;
        }else if(this.Newly.recipientTelephone == ""){
              this.$message.error("收件人联系方式不能为空！")
              return;
        }
        ajaxPost(Baseurl + "receivingAddressController/insertReceivingAddress",this.Newly).then(res=>{
            if(res.status == 200){
                 this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.NewAddVisible = false;
            }else{
                  this.$message.error(res.error);
            }
        })
    },
    // 选择地址列表
    SelectSite(){
        let Try = {
            companyId:this.str.company_id
        }
        ajaxPost(Baseurl +"logisticsController/selectReceivingAddressListByCompanyId",Try).then(res=>{
            if(res.status==200){
                this.SiteList = res.data.data;
                 this.SelectVisible = true;
            }
        })

    },
    // 选择地址
    addressConfirm(item){
         this.SalesFields.receivingAddressId = item.id;
        this.innerData = item;
        this.SelectVisible = false;
    },
    init(e) {
      this.dialogVisible = true;
      this.sondataId = e.id;
      this.EditTable.inventoryNumber = e.inventoryNumber;
      this.initAjax();
    },
    initAjax(){
      var obj = {
        id:this.sondataId,
        roleId:this.str.rid
      }
    //   console.log(1)
      ajaxPost(Baseurl + "inventoryController/getInventoryDetailsById",obj).then(res => {
          if(res.data.code == 200){
              this.sondata = res.data.data
              this.EditData()
          }else(
              this.$message.error(res.data.data)
          )
      })
      ajaxPost(Baseurl+"inventoryController/getInventoryBatchsByInventoryNumber",this.EditTable).then(res=>{
          this.EditTableData = res.data.data;
        //   console.log(this.EditTableData)
          this.$nextTick(()=>{
                 this.$refs.EditTableDo.doLayout()
            })
      })
    },
    EditData(){
      this.fileList = []
      let urlStr = this.sondata.imagesList
      urlStr.forEach(item => {
          let obj = new Object();
          obj.url = item;
          this.fileList.push(obj);
      });
      this.imagesList=this.fileList;
      this.linkList = [];
      this.linkList = this.sondata.productLinkList;
      this.fullName = this.sondata.productFullName;
      this.simpleName = this.sondata.productSimpleName;
      this.inventorySku = this.sondata.inventorySku;
      this.describe = this.sondata.productDescription;
      this.Num = this.sondata.predictCount;
      this.id = this.sondata.id;
      this.inventorySkus = this.sondata.inventorySkus;

      this.inventorySkus1 = this.sondata.inventorySkus1;
      this.inventorySkus2 = this.sondata.inventorySkus2;
      this.inventorySkus3 = this.sondata.inventorySkus3;
    },
    handleClick(tab, event) {
        if(tab.index == 0){
          this.Skutype = 1
        }else if(tab.index == 1){
          this.Skutype = 2
        }
    },
    handleRemove(file, fileList) {
        this.imagesList = fileList
        this.fileList = this.imagesList
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.ImageVisible = true;
    },
    //图片上传
    handleAvatarSuccess(file, fileList) {
            file=Object.assign(file,{
                'url':file.data
            })
            this.fileList.push(file);
            this.imagesList = this.fileList
            // console.log(fileList)
    },
    AddprocurementLink(){
            // this.AddLink = true
            if(this.linkList.length<5){
                this.linkList.push("")
            }else{
                this.$message.error('采购链接已达上限！');
            }
            // console.log(this.linkList)
    },
    delLink(index){
            this.linkList.splice(index,1)
            // console.log(index)
    },
    Add(){
     
      for(var i=0;i<this.imagesList.length;i++){
            this.arrList.push(this.imagesList[i].url)
      }
      var obj = {
            roleId:this.str.rid,
            id:this.id,
            imagesList:this.arrList,
            productLinkList:this.linkList,
            // 全称
            productFullName:this.fullName,
            // 简称
            productSimpleName:this.simpleName,
            // 描述
            productDescription:this.describe,
            predictCount:this.Num,
            companyId:this.str.company_id,
            roleId:this.str.rid,
            // 尺寸
            inventorySku:this.inventorySku
      }
    //   console.log(obj.inventorySkus)
      if(obj.productFullName=="" ||obj.productFullName==null){
          this.$message.error("商品全称不能为空！");
          return;
      }else if(obj.productSimpleName=="" ||obj.productSimpleName==null){
        this.$message.error("商品简称不能为空！");
          return;
      }
      else if(obj.inventorySku=="" ||obj.inventorySku==null){
        this.$message.error("商品尺寸不能为空！");
          return;
      }
      else if(obj.productDescription=="" ||obj.productDescription==null){
        this.$message.error("商品描述不能为空！");
          return;
      }
      // console.log(obj)
       this.dialogVisible = false;
      ajaxPost(Baseurl + "inventoryController/updateInventoryById",obj).then(res => {
                if(res.data.code == 200){
                    this.$message({
                        message: '编辑自建库存成功',
                        type: 'success'
                    });
                    this.$emit("Editinventory")
                }else(
                    this.$message.error(res.data.data)
                )
                this.imagesList = []
                this.fileList = []
                this.arrList = []
      })
      
    },
    cancel(){
            this.dialogVisible = false
            this.linkList = []
            this.fileList = []
            this.arrList = []
            this.imagesList = []
            this.fullName = ""
            this.simpleName = ""
            this.describe = ""
            this.Num = ""
    },
    supplement(){
        this.innerVisible = true
    },
    addinventory(){
      var obj = {
        id:this.id,
        companyId:this.str.company_id,
        predictCount:this.inventoryNum
      }
      ajaxPost(Baseurl + "inventoryController/copyInventory",obj).then(res => {
          if(res.data.code == 200){
              this.$message({
                  message: '补充库存成功',
                  type: 'success'
              });
              this.$emit("Editinventory");
               this.initAjax();
          }else(
              this.$message.error(res.data.data)
          )
          this.inventoryNum = ""
      })
      this.innerVisible = false;
     
    //   this.dialogVisible = false;
    },
    search(){
      this.loading = true
      var obj = {
          page:this.currentPage,
          size:this.size,
          searchString:this.searchInput,
          type: this.Skutype,
          roleId:this.str.rid,
          companyId:this.str.company_id
      }
      ajaxPost(Baseurl + "inventoryController/selectSkuList",obj).then(res => {
          if(res.data.code == 200){
              this.total = res.data.data.total
              this.productList = res.data.data.list
              this.loading = false
              this.currentPage = 1
          } 
      })
    },
    AddSku(){
      var obj = {
          roleId:this.str.rid,
          id:this.sondata.id,
          inventoryNumber:this.sondata.inventoryNumber,
          companyId:this.str.company_id,
          inventorySkus:this.multipleSelection,
          skuType:this.Skutype
      }
      ajaxPost(Baseurl + "inventoryController/updateSkusByInventoryId",obj).then(res => {
          if(res.data.code == 200){
            this.$message({
              message: '匹配SKU成功',
              type: 'success'
            });
            if(this.Skutype == 1){
              this.inventorySkus1 = res.data.data
            }else if(this.Skutype == 2){
              this.inventorySkus2 = res.data.data
            }else if(this.Skutype == 3){
              this.inventorySkus3 = res.data.data
            }
            this.initAjax()
          }else{
            this.$message.error(res.data.data);
          }
          this.innerVisible1 = false
      })
    },
    cancelMatching(val){
    //   console.log(val)
      var obj = {
          id:val.id
      }
      ajaxPost(Baseurl + "inventoryController/deleteInventorySkuByInventoryId",obj).then(res => {
          if(res.data.code == 200){
            this.$message({
              message: '取消匹配成功',
              type: 'success'
            });
            // console.log(res.data)
            if(this.Skutype === 1){
              this.inventorySkus1 = res.data.data
            }else if(this.Skutype === 2){
              this.inventorySkus2 = res.data.data
            }else if(this.Skutype === 3){
              this.inventorySkus3 = res.data.data
            }
            this.initAjax()
          }else{
            this.$message.error(res.data.data);
          }
      })
    },
    matchingSku1(){
      this.innerVisible1 = true
      this.loading = true
      this.Skutype = 1
      this.search()
    },
    matchingSku2(){
      this.innerVisible1 = true
      this.loading = true
      this.Skutype = 2
      this.search()
    },
    matchingSku3(){
      this.Skutype = 3
        this.$prompt('请输入SKU', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
            var obj = {
                roleId:this.str.rid,
                id:this.sondata.id,
                inventoryNumber:this.sondata.inventoryNumber,
                companyId:this.str.company_id,
                inventorySkus:[{inventorySku:value,skuType:this.Skutype}],
            }
            ajaxPost(Baseurl + "inventoryController/updateSkusByInventoryId",obj).then(res => {
                if(res.data.code == 200){
                  this.$message({
                    message: '匹配SKU成功',
                    type: 'success'
                  });
                  this.inventorySkus3 = res.data.data
                  this.initAjax()
                }else{
                  this.$message.error(res.data.data);
                }
            })
        })
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
        // console.log(this.multipleSelection)
    },
    handleSizeChange(val) {
            this.loading = true
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
    },
    handleCurrentChange(val) {
            this.loading = true
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search()
    },
    destruction(){
          this.$confirm('是否确定销毁？', '销毁', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var obj = {
            companyId:this.str.company_id,
            roleId:this.str.rid,
            inventoryId:this.sondata.id,
            inventoryNumber:this.sondata.inventoryNumber,
            operateType:3
          }
          ajaxPost(Baseurl + "inventoryController/insertInventoryOperate",obj).then(res => {
              if(res.data.code == 200){
                this.$message({
                  message: '销毁成功',
                  type: 'success'
                });
                this.$emit("Editinventory")
              }else{
                this.$message.error(res.data.data);
              }
              this.dialogVisible = false
          })
        })
    },
  }
};
</script>

<style lang="scss" scoped>
/deep/{
    .el-pagination{
        margin-right: 0px!important;
    }
    .form .el-form-item{
        margin-bottom: 5px;
    }
     .out-handle-box .el-input-number__decrease ,.out-handle-box .el-input-number__increase{
        top: 5px;
        height: 28px !important;
        line-height: 28px  !important;
    }
    .out-handle-box{
        margin-left: 15px;
    }
    .out-handle-box .el-row{
        margin: 10px 0;
    }
}

</style>
<style>

.body{
    width: 100%;
}
.link{
    display: inline-block;
    width: 100%;
    height: 20px;
    text-align: center;
    line-height: 20px;
}
.prduct_img {
  width: 300px;
  height: 300px;
}
.page{
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>